import "./index.scss";
import "../../locales/i18n";

import cx from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useOutsideClick from "react-outside-click-hook";
import { /*useDispatch,*/ useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ReactTooltip from "react-tooltip";

// import { LOGOUT_URL } from "src/constants/auth";
import { TUserMetadata } from "src/routes/FirstLogin";
// import { TExoAppContext } from "src/types/exoContext.types";

import { SimpleDropdown } from "@/components/components/Dropdown";
import { OptionVariant } from "@/components/components/Dropdown/dropdown.enum";
// import { Chart, Chat, Ellipse, Home, PhoneBoxed, Setting, Support, Users } from "@/components/icons";
import { Chart, Chat, Layers, Moon, PhoneBoxed, Setting, Sun, Support, Users } from "@/components/icons";
import Logout from "@/components/icons/LogOutTextKit";
// import { redirectToLogoutAC } from "@/messenger/actions/saga";
import { NAV_CHAT, NAV_LOG_OUT, NAV_MODULE, NAV_REPORTS, NAV_SUPPORT } from "@/messenger/constants/domID";
import { CHAT, MODULE, SETTINGS } from "@/messenger/constants/routing";
import { customerSelector } from "@/messenger/ducks/entities/customers";
import { deviceTypeSelector } from "@/messenger/ducks/selectors/general";
import { widgetStateSelectorsCustom } from "@/messenger/ducks/userInterface/widgetsState";
import { useFetchUserMetadata } from "@/messenger/hooks/useFetchUserMetadata";
import { toggleHideRingCentral } from "@/messenger/integration/RingCentral";
// import { useUpdateMetadata } from "@/messenger/providers/Auth0Provider";
import { useAuth, useUpdateMetadata } from "@/messenger/providers/AuthProvider";
import { getExoHandler } from "@/messenger/routes/helper";
//import { NAV_ACCOUNTS, NAV_CHAT, NAV_LOG_OUT, NAV_REPORTS, NAV_SUPPORT, NAV_WELCOME } from "@/messenger/constants/domID";
import { activeModuleIdSelector, /*exoAppContextSelector*/ } from "@/messenger/selectors";
import { TCustomer } from "@/messenger/types/entities/conversation";
import { detectMobile } from "@/messenger/utils/deviceType";
// import { executeStringifiedJS, handleOnKeyDown, modulesEnabled } from "@/messenger/utils/helpers";
import { executeStringifiedJS, getDomainHost, handleOnKeyDown } from "@/messenger/utils/helpers";
import appConfig from "@/messenger/config";

interface TNavigationMenuProps {
    customer: TCustomer;
    isQA: boolean;
}

const NavigationMenu = ({ isQA, customer: { config: { webapp } } }: TNavigationMenuProps) => {
    const history = useHistory();
    const handleOnClick = (url) => () => {
        //const newUrl =  url.replace(window.location.origin,"");
        //if (newUrl.length > url.length)
        history.push(url);
        //window.location.href = url.replace(window.location.origin,""); 
    };

    const isChat = (window.location.pathname.indexOf("/chat") !== -1) ? true : false;
    const isReports = (window.location.pathname.indexOf("/reports") !== -1) ? true : false;
    const isExoPerson = (window.location.pathname.indexOf("/exo/person") !== -1) ? true : false;
    const isExo = !isExoPerson && (window.location.pathname.indexOf("/exo") !== -1) ? true : false;
    const handleSupportClick = executeStringifiedJS(webapp?.supportJsFunction);

    return <>
        <button aria-label="Chat" id={NAV_CHAT}
            className={cx({
                "c-navigation--nav-item": true,
                "c-navigation--nav-item_active": isChat,
            })}
            onClick={handleOnClick("/chat")}>
            <div className="c-navigation--nav-item_action c-navigation--nav-item_action__fill-icon" >
                <Chat />
            </div>
        </button>

        <div id={NAV_REPORTS}
            className={cx({
                "c-navigation--nav-item": true,
                "c-navigation--nav-item_active": isReports,
            })}
            onClick={handleOnClick("/reports")}>

            <div className="c-navigation--nav-item_action c-navigation--nav-item_action__fill-icon" >
                <Chart />
            </div>
        </div>
        {isQA && <div id={"exo-person"}
            className={cx({
                "c-navigation--nav-item": true,
                "c-navigation--nav-item_active": isExoPerson,
            })}
            onClick={handleOnClick("/exo/person")}>

            <div className="c-navigation--nav-item_action c-navigation--nav-item_action__stroke-icon" >
                <Users />
            </div>
        </div>}
        {isQA && <div id={"exo"}
            className={cx({
                "c-navigation--nav-item": true,
                "c-navigation--nav-item_active": isExo,
            })}
            onClick={handleOnClick("/exo")}>

            <div className="c-navigation--nav-item_action c-navigation--nav-item_action__stroke-icon" >
                <Layers />
            </div>
        </div>}

        {webapp?.supportJsFunction && 1 > 2 && <div id={NAV_SUPPORT}
            className={cx({
                "c-navigation--nav-item": true,
                "c-navigation--nav-item_active": false,
                "c-navigation--nav-item_action__stroke-icon": true,
            })}
            onClick={handleSupportClick}>
            <div className="c-navigation--nav-item_action" >
                <Support />
            </div>
        </div>}
    </>;
};

const Navigation = () => {
    const menu = useRef<HTMLDivElement>(null);
    const supportMenu = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState<boolean>(false);
    const [context, setContext] = useState<any>(null);
    const [openSupport, setOpenSupport] = useState<boolean>(false);
    const [isQA, setIsQA] = useState<boolean>(false);
    const selectedIcon = useSelector(activeModuleIdSelector) ? NAV_MODULE : NAV_CHAT;
    const { t } = useTranslation();
    const auth0 = useAuth();
    const [accessToken, userMetadata, setUserMetadata, metadataUrl] = useFetchUserMetadata();

    const onMetadataChange = (metadata: any) => {
        setUserMetadata(metadata);
    };

    const updateMetadata = useUpdateMetadata(metadataUrl, accessToken, onMetadataChange, auth0.user, userMetadata);

    // const appContext: TExoAppContext = useSelector(exoAppContextSelector);
    // if (appContext) {}
    const customers = useSelector(customerSelector.selectAll);

    const history = useHistory();
    const theme = localStorage.getItem("theme") ? localStorage.getItem("theme") : "light";

    const isMobile = detectMobile(useSelector(deviceTypeSelector));

    const moduleWidgetStates = useSelector(widgetStateSelectorsCustom.selectAllByTypeModule);

    // const dispatch = useDispatch();


    useEffect(() => {
        const host = getDomainHost();
        (async () => {
            const data = await getExoHandler("project", null, "context", "textkit");
            if (data) {
                setContext(data);
            }
        })();

        if (host.includes("qa")) setIsQA(true);
    }, []);



    useOutsideClick(menu, () => {
        setTimeout(() => setOpen(false), 5);
    }, open);

    useOutsideClick(supportMenu, () => {
        setTimeout(() => setOpenSupport(false), 5);
    }, openSupport);

    const onClickLogOut = async () => {
        localStorage.removeItem('auth');
        (await appConfig.authConfig()).ifSome(auth => {
            const redirectUri = auth?.logout_redirect_uri || window.location.origin
            if (window.location.href.includes('textkit.statflo.com')) {
                window.location.replace(`https://sso.textkit.statflo.com/oauth2/logout/?client_id=${auth.client_id}&redirect_uri=${redirectUri}`)
            } else {
                window.location.replace(`https://ssoth.is/oauth2/logout/?client_id=${auth.client_id}&redirect_uri=${redirectUri}`)
            }
        }); 
    };

    const handleChangeDarkMode = () => {
        if (theme === "light") {
            localStorage.setItem("theme", "dark");
        } else if (theme === "dark") {
            localStorage.setItem("theme", "purple");
        } else {
            localStorage.setItem("theme", "light");
        }
        window.location.reload();
    };

    const handleChangeSettings = () => {
        history.push(`/${SETTINGS}`);
    };

    const handleClearMeta = () => {
        const userMetadata: TUserMetadata = {
            wasFirstLoggedIn: false,
            timezone: null,
            branch: null,
        };
        if (isQA) {
            updateMetadata(userMetadata);
            window.location.reload();
        } else {
            console.log("Cannot clear metadata in production");
        }
    };

    const customer = customers?.length > 0 && customers[0];
    const isChat = (window.location.pathname.indexOf("/chat") !== -1) ? true : false;
    const isReports = (window.location.pathname.indexOf("/reports") !== -1) ? true : false;
    const config = customer?.config;
    const ringCentralEnabled = config?.ringCentralEnabled ? false : false;
    const host = getDomainHost();

    const renderModuleButtons = () => {
        const baseClassName = "c-navigation--menu";
        const optionClassNames = {
            icon: `${baseClassName}__dd-options`,
        };
        const onOptionClick = (o) => {
            history.push(`/${MODULE}/${o.label}`);
        };
        const options = moduleWidgetStates.map(item => ({
            label: item.path,
            ariaLabel: item.id,
            heading: item.id,
        }));

        //https://icons.radix-ui.com
        //https://remixicon.com

        const renderOverride = (_, toggleMenu: () => void) =>
            <>
                <button className={cx({
                        "c-navigation--nav-item": true,
                        "c-navigation--nav-item_active": selectedIcon === NAV_MODULE,
                    })}
                    onClick={toggleMenu}
                    data-tip
                    data-for={"LAYERS"}
                >
                    <div 
                        style={{ zIndex: 9999999 }} 
                        className={"c-navigation--nav-item_action c-navigation--nav-item_action__fill-icon"}
                    >
                            {<Layers />}
                    </div>
                </button>
                <ReactTooltip id={"LAYERS"} place="bottom" effect="solid" className="hover_tooltip">
                    {t("Apps")}
                </ReactTooltip>
            </>

        return <SimpleDropdown
            isMobileView={isMobile}
            onSelect={(o) => onOptionClick(o)}
            options={options}
            optionsVariant={isMobile ? OptionVariant.ACCENTED : OptionVariant.NORMAL}
            optionClassNames={optionClassNames}
            optionsContainerClassNames={{ menu: `${baseClassName}__menu`, container: "c-navigation__mobile__container" }}
            renderOverride={renderOverride}
            search={false}
        />;
    };

    const onChatClick = () => {
        history.push(`/${CHAT}`);
    };

    const handleOnClick = (url) => () => {
        //const newUrl =  url.replace(window.location.origin,"");
        //if (newUrl.length > url.length)
        history.push(url);
        //window.location.href = url.replace(window.location.origin,""); 
    };

    return (
        <div className="c-navigation" role="navigation" aria-label={t("left")}>
            <div className="c-navigation--top">
                {context?.logo ? (
                    <div className="c-navigation--logo_container">
                        <div className="c-navigation--logo"><img width={context?.logoWidth ? context?.logoWidth : "36px"} src={context.logo} /></div>
                    </div>
                ) : (
                    <div className="c-navigation--logo-placeholder">
                        {host[0]}
                    </div>
                )}
                {/* place top items here */}
                {(moduleWidgetStates?.length > 0 || customer) &&
                    <>
                        <button id={NAV_CHAT}
                            className={cx({
                                "c-navigation--nav-item": true,
                                "c-navigation--nav-item_active": isChat,
                            })}
                            onClick={onChatClick}
                            data-tip
                            data-for={"CHAT"}
                        >
                            <div style={{ zIndex: 9999999, }}  className="c-navigation--nav-item_action c-navigation--nav-item_action__fill-icon" >
                                <Chat />
                            </div>
                        </button>
                        <ReactTooltip id={"CHAT"} place="bottom" effect="solid" className="hover_tooltip">
                            {t("Chats")}
                        </ReactTooltip>
                        <button id={NAV_REPORTS}
                            className={cx({
                                "c-navigation--nav-item": true,
                                "c-navigation--nav-item_active": isReports,
                            })}
                            onClick={handleOnClick("/reports")}
                            data-tip
                            data-for={"CHART"}
                        >
                            <div style={{ zIndex: 9999999 }}  className="c-navigation--nav-item_action c-navigation--nav-item_action__fill-icon" >
                                <Chart />
                            </div>
                        </button>
                        <ReactTooltip id={"CHART"} place="bottom" effect="solid" className="hover_tooltip" >
                            {t("Reports")}
                        </ReactTooltip>
                    </>
                }

                {ringCentralEnabled && (
                    <>
                        <button className="c-navigation--nav-item" onClick={toggleHideRingCentral}>
                            <div className="c-navigation--nav-item_action">
                                <PhoneBoxed />
                            </div>
                        </button>
                        <NavigationMenu customer={customer} isQA={isQA} />
                    </>
                )}
                {moduleWidgetStates?.length > 0 && renderModuleButtons()}
            </div>
            <div className="c-navigation--bottom">
                <div
                    ref={menu}
                    className={cx({
                        "c-navigation--nav-item": true,
                        "c-navigation--nav-item_active": open,
                    })}
                    onClick={() => setOpen(!open)}
                    onKeyDown={e => handleOnKeyDown(e, {
                        enter: () => setOpen(!open),
                        esc: () => setOpen(false),
                        shiftTab: () => setOpen(false),
                    })}
                    tabIndex={0}
                >
                    <div className="c-navigation--nav-item c-navigation--nav-item_action--last c-navigation--nav-item_action__fill-icon">
                        <Users />
                    </div>
                    {open && (
                        <div className="c-navigation--menu">
                            <button
                                className="c-navigation--menu_item"
                                onClick={handleChangeDarkMode}
                                onKeyDown={e => handleOnKeyDown(e, {
                                    enter: () => handleChangeDarkMode(),
                                    esc: () => setOpen(false),
                                    shiftTab: () => setOpen(false),
                                })}

                            >
                                {theme === "dark" ? (<Sun width={16} height={16} fill={"hsl(0, 0%, 60%)"} />)
                                    : (<Moon width={16} height={16} fill={"hsl(0, 0%, 60%)"} />)}
                                <span>{theme === "dark" ? t("Deep Mode") : theme === "purple" ? t("Light Mode") : t("Dark Mode")}</span>
                            </button>
                            <button
                                className="c-navigation--menu_item"
                                onClick={handleChangeSettings}
                                onKeyDown={e => handleOnKeyDown(e, {
                                    enter: () => handleChangeSettings(),
                                    esc: () => setOpen(false),
                                    shiftTab: () => setOpen(false),
                                })}

                            >
                                <Setting width={16} height={16} fill={"hsl(0, 0%, 60%)"} />
                                <span>{t("Settings")}</span>
                            </button>
                            {isQA && <button className="c-navigation--menu_item"
                                onClick={handleClearMeta}
                                onKeyDown={e => handleOnKeyDown(e, {
                                    enter: () => handleClearMeta,
                                    esc: () => setOpen(false),
                                    shiftTab: () => setOpen(false),
                                })}

                            >
                                <span>{t("Clear Metadata")}</span>
                            </button>}
                            <button className="c-navigation--menu_item"
                                onClick={onClickLogOut}
                                onKeyDown={e => handleOnKeyDown(e, {
                                    enter: () => onClickLogOut(),
                                    esc: () => setOpen(false),
                                    shiftTab: () => setOpen(false),
                                })}
                                id={NAV_LOG_OUT}

                            >
                                <Logout width={16} height={16} fill={"hsl(0, 0%, 60%)"} />
                                <span>{t("Log Out")}</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Navigation;
